import { customElement, autoinject } from 'aurelia-framework';
import { IMdcDatepickerDialogData, MdcDatepickerDialog } from '@aurelia-toolkit/mdc-datepicker';
import { MdcDialogService } from '@aurelia-mdc-web/dialog';
import { format } from 'date-fns';
import { ManualPricesClient, } from '@dynamik/common/clients/transaction-clients';
import { ICellEditorParams } from 'ag-grid-community';
import { AlertService } from '@aurelia-toolkit/alert';
import { usingTraceAwareProgress } from '@dynamik/common';

@customElement('ag-from-date-range-editor')
@autoinject
export class AgFromDateRangeEditor {
  constructor(public alertService: AlertService, private dialogService: MdcDialogService, private manualPricesClient: ManualPricesClient) { }

  private params: ICellEditorParams & { instrumentId: number; setValue(value: string) };
  private value: Date;

  bind(bindParams: { params: AgFromDateRangeEditor['params'] }) {
    this.params = bindParams.params;
    this.value = this.params.value ? new Date(Date.parse(this.params.value as string)) : undefined;
  }

  getValue() {
    return format(this.value, 'yyyy-MM-dd\'T\'HH:mm');
  }

  isPopup() {
    return false;
  }

  @usingTraceAwareProgress()
  async openDatePicker() {
    const data: Partial<IMdcDatepickerDialogData> = {
      date: this.value,
      options: {
        showAll: true
      }
    };
    const result = await this.alertService.open({ viewModel: MdcDatepickerDialog, model: data });
    if (result === 'ok') {
      if (data.date) {
        this.params.setValue(format(data.date, 'yyyy-MM-dd\'T\'HH:mm'));
      } else {
        this.value = undefined;
      }
    }
  }

}
